import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space } from 'antd';

import { ButtonOK } from 'src/components/Forms/Button';
import SearchInput from 'src/components/InfoObat/Search';
import { HISTORY_SEARCH_KEYWORDS_OBAT } from 'src/constants/localStorage';
import { ARTICLE_BY_GROUP } from 'src/constants/services';
import { useSearch } from 'src/hooks';
import useDebounce from 'src/utils/hook/useDebounce';

import classes from './style.module.css';

const SearchObat: FC = () => {
	const router = useRouter();

	const [searchTerm, setSearchTerm] = useState<string>(
		router.query.search ? decodeURIComponent(router.query.search as string) : '',
	);

	const [visibleOption, setVisibleOption] = useState<boolean>(false);

	const debouncedSearchTerm = useDebounce(searchTerm, 300);

	const { refetch, data, isLoading } = useSearch(ARTICLE_BY_GROUP.model.obat, debouncedSearchTerm);

	const handleSearchDebounce = async () => {
		refetch();
	};

	const saveHistorySearch = (keyword: string) => {
		const historySearchKeywords: string[] =
			JSON.parse(localStorage.getItem(HISTORY_SEARCH_KEYWORDS_OBAT) as string) ?? [];

		const isDuplicated = historySearchKeywords.some((h) => h === keyword);

		if (!isDuplicated && !!keyword) historySearchKeywords.unshift(keyword);
		else {
			const index = historySearchKeywords.indexOf(keyword);
			if (index > -1) {
				historySearchKeywords.splice(index, 1);
				historySearchKeywords.unshift(keyword);
			}
		}

		localStorage.setItem(HISTORY_SEARCH_KEYWORDS_OBAT, JSON.stringify(historySearchKeywords));
	};

	const onSearch = async (search?: string) => {
		saveHistorySearch(search ?? searchTerm);
		setVisibleOption(false);
		await router.push({
			pathname: '/obat',
			query:
				searchTerm != '' || search
					? {
							search: encodeURIComponent(search ?? searchTerm),
							active: true,
						}
					: '',
		});
	};

	useEffect(() => {
		if (searchTerm !== '') handleSearchDebounce();
	}, [debouncedSearchTerm]);

	useEffect(() => {
		setSearchTerm(router.query.search ? decodeURIComponent(router.query.search as string) : '');
	}, [router.query.search]);

	return (
        <Space.Compact className={classes['auto-complete']}>
            <SearchInput
				placeholder="Cari Obat"
				search={searchTerm}
				setSearch={setSearchTerm}
				result={data ?? []}
				visibleOption={visibleOption}
				setVisibleOption={setVisibleOption}
				onSearch={onSearch}
				onFocus={handleSearchDebounce}
				loading={isLoading}
			/>
            <ButtonOK
				size="large"
				text="Cari"
				className={classes.button}
				icon={<SearchOutlined />}
				onClick={() => onSearch()}
			/>
        </Space.Compact>
    );
};

export default SearchObat;
